import React from 'react';
import Widget from '../../comps/Widget.js';
import LoadingApp from '../../comps/LoadingApp.js';
import CaptureEmail from '../../comps/CaptureEmail.js';
import Login from '../../comps/Login.js';
import VerifyMessage from '../../comps/VerifyMessage.js';
import BlockedMessage from '../../comps/BlockedMessage.js';
import LockedMessage from '../../comps/LockedMessage.js';
import ResetPasswordMessage from '../../comps/ResetPasswordMessage.js';
import LinkAccountRegister from '../../comps/LinkAccountRegister.js';
import LinkAccount from '../../comps/LinkAccount.js';

class ViewBuilder {

  constructor(controller, translationService, localeService) {

    let context = {
      controller: controller,
      translationService: translationService,
      localeService: localeService
    };

    this.getWidget = this.getWidget.bind(context);
    this.getCaptureEmailView = this.getCaptureEmailView.bind(context);
    this.getLoginView = this.getLoginView.bind(context);
    this.getVerifyMessageView = this.getVerifyMessageView.bind(context);
    this.getBlockedMessageView = this.getBlockedMessageView.bind(context);
    this.getLockedMessageView = this.getLockedMessageView.bind(context);
    this.getResetPasswordMessageView = this.getResetPasswordMessageView.bind(context);
    this.getLinkAccountRegisterView = this.getLinkAccountRegisterView.bind(context);
    this.getLinkAccountView = this.getLinkAccountView.bind(context);

    controller.handleSuccess = controller.handleSuccess.bind(controller);
    controller.handleFailure = controller.handleFailure.bind(controller);
    controller.handleEmailChange = controller.handleEmailChange.bind(controller);
    controller.handlePasswordChange = controller.handlePasswordChange.bind(controller);
    controller.handleRememberMeChange = controller.handleRememberMeChange.bind(controller);
    controller.processCaptureEmailForm = controller.processCaptureEmailForm.bind(controller);
    controller.processLoginForm = controller.processLoginForm.bind(controller);
    controller.processResetPasswordForm = controller.processResetPasswordForm.bind(controller);
    controller.processLinkAccountForm = controller.processLinkAccountForm.bind(controller);
    controller.processRegisterForm = controller.processRegisterForm.bind(controller);

  }

  getWidget() {

    return React.createElement(
      Widget,
      {
        view: this.controller.getState('view')
      },
      null
    );

  }

  getLoadingAppView() {

    return React.createElement(
      LoadingApp,
      null,
      null
    );

  }

  getCaptureEmailView() {

    return React.createElement(
      CaptureEmail,
      {
        translationService: this.translationService,
        actionInProgress: this.controller.getState('actionInProgress'),
        formInProgress: this.controller.getState('formInProgress'),
        onClose: this.controller.handleFailure,
        formError: this.controller.getState('formError'),
        emailValue: this.controller.getState('emailAddress'),
        emailAddressErrorMessage: this.controller.getState('emailAddressErrorMessage'),
        onEmailChange: this.controller.handleEmailChange,
        onButtonClick: this.controller.processCaptureEmailForm
      },
      null
    );

  }

  getLoginView() {

    return React.createElement(
      Login,
      {
        translationService: this.translationService,
        actionInProgress: this.controller.getState('actionInProgress'),
        onClose: this.controller.handleFailure,
        formError: this.controller.getState('formError'),
        emailValue: this.controller.getState('emailAddress'),
        emailAddressErrorMessage: this.controller.getState('emailAddressErrorMessage'),
        onEmailChange: this.controller.handleEmailChange,
        passwordValue: this.controller.getState('password'),
        passwordErrorMessage: this.controller.getState('passwordErrorMessage'),
        onPasswordChange: this.controller.handlePasswordChange,
        onPasswordHelpClick: this.controller.processResetPasswordForm,
        onRememberMeChange: this.controller.handleRememberMeChange,
        onButtonClick: this.controller.processLoginForm
      },
      null
    );

  }

  getLinkAccountRegisterView() {

    return React.createElement(
      LinkAccountRegister,
      {
        translationService: this.translationService,
        actionInProgress: this.controller.getState('actionInProgress'),
        formInProgress: this.controller.getState('formInProgress'),
        provider: this.controller.getState('openIdProvider'),
        onClose: this.controller.handleFailure,
        formError: this.controller.getState('formError'),
        emailValue: this.controller.getState('emailAddress'),
        emailAddressErrorMessage: this.controller.getState('emailAddressErrorMessage'),
        onEmailChange: this.controller.handleEmailChange,
        passwordValue: this.controller.getState('password'),
        passwordErrorMessage: this.controller.getState('passwordErrorMessage'),
        onPasswordChange: this.controller.handlePasswordChange,
        onPasswordHelpClick: this.controller.processResetPasswordForm,
        onRememberMeChange: this.controller.handleRememberMeChange,
        onLinkAccountButtonClick: this.controller.processLinkAccountForm,
        askForEmailForRegister: this.controller.getState('askForEmailForRegister'),
        onRegisterButtonClick: this.controller.processRegisterForm,
        language: this.localeService.getLanguage()
      },
      null
    );

  }

  getLinkAccountView() {

    return React.createElement(
      LinkAccount,
      {
        translationService: this.translationService,
        actionInProgress: this.controller.getState('actionInProgress'),
        provider: this.controller.getState('openIdProvider'),
        onClose: this.controller.handleFailure,
        formError: this.controller.getState('formError'),
        emailValue: this.controller.getState('emailAddress'),
        passwordValue: this.controller.getState('password'),
        passwordErrorMessage: this.controller.getState('passwordErrorMessage'),
        onPasswordChange: this.controller.handlePasswordChange,
        onPasswordHelpClick: this.controller.processResetPasswordForm,
        onRememberMeChange: this.controller.handleRememberMeChange,
        onButtonClick: this.controller.processLinkAccountForm
      },
      null
    );

  }

  getVerifyMessageView() {

    return React.createElement(
      VerifyMessage,
      {
        translationService: this.translationService,
        onClose: this.controller.handleFailure,
        onButtonClick: this.controller.handleFailure
      },
      null
    );

  }

  getBlockedMessageView() {

    return React.createElement(
      BlockedMessage,
      {
        translationService: this.translationService,
        onClose: this.controller.handleFailure,
        onButtonClick: this.controller.handleFailure
      },
      null
    );

  }

  getLockedMessageView() {

    return React.createElement(
      LockedMessage,
      {
        translationService: this.translationService,
        onClose: this.controller.handleFailure,
        onButtonClick: this.controller.handleFailure
      },
      null
    );

  }

  getResetPasswordMessageView() {

    return React.createElement(
      ResetPasswordMessage,
      {
        translationService: this.translationService,
        onClose: this.controller.handleFailure,
        onButtonClick: this.controller.handleFailure
      },
      null
    );

  }

}

export default ViewBuilder;
